import { Radio as RadioPrimitive } from '@base-ui/react/radio';

import CircleIcon from '@/assets/svg/radio-checked.svg?react';
import { cn } from '@/lib/utils';

export type RadioGroupItemProps = RadioPrimitive.Root.Props;

const RadioGroupItem = ({ className, ...props }: RadioGroupItemProps) => {
  return (
    <RadioPrimitive.Root
      nativeButton
      data-slot="radio-group-item"
      render={<button />}
      className={cn(
        'peer group group/radio-group-item relative flex aspect-square size-4 shrink-0 items-center justify-center rounded-full border-2 border-gray-900 bg-white text-gray-900 outline-none',
        'cursor-pointer transition-colors',
        'data-disabled:border-gray-500 data-disabled:text-gray-300',

        // checked
        'data-checked:border-green-600 data-checked:bg-white data-checked:text-green-600',

        // interactions
        'hover:border-green-500 hover:text-green-500',
        'focus:border-green-500 focus:text-green-500 focus:before:bg-green-500',
        "after:pointer-events-none after:absolute after:-inset-px after:rounded-xs after:content-['']",
        'focus:after:inset-1/2 focus:after:-mt-3 focus:after:-ml-3 focus:after:size-6 focus:after:rounded-sm focus:after:bg-green-500/20',
        'data-disabled:cursor-not-allowed data-disabled:border-gray-500! data-disabled:bg-white! data-disabled:text-gray-500!',

        // invalid
        'aria-invalid:border-red-400 aria-invalid:text-red-400',
        'aria-invalid:hover:border-red-500 aria-invalid:hover:text-red-500',
        'aria-invalid:data-checked:border-red-500 aria-invalid:data-checked:text-red-500',
        'aria-invalid:focus:border-red-400 aria-invalid:focus:text-red-400 aria-invalid:focus:before:bg-red-400',
        'aria-invalid:focus:after:bg-red-400/20',
        'group-data-[invalid=true]/field:border-red-400 group-data-[invalid=true]/field:text-red-400',
        'group-data-[invalid=true]/field:hover:border-red-500 group-data-[invalid=true]/field:hover:text-red-500',
        'group-data-[invalid=true]/field:data-checked:border-red-500 group-data-[invalid=true]/field:data-checked:text-red-500',
        'group-data-[invalid=true]/field:focus:border-red-400 group-data-[invalid=true]/field:focus:text-red-400',
        'group-data-[invalid=true]/field:focus:before:bg-red-400',
        'group-data-[invalid=true]/field:focus:after:bg-red-400/20',

        // disabled
        'group-data-[disabled=true]/field:opacity-50 disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <RadioPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="flex size-4 items-center justify-center group-aria-invalid/radio-group-item:text-red-400 group-data-[invalid=true]/field:text-red-400"
      >
        <CircleIcon className="absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2" />
      </RadioPrimitive.Indicator>
    </RadioPrimitive.Root>
  );
};

export default RadioGroupItem;
